export interface RecibosAgenciaMod {
    
    id: number;
    idCliente: string;
    cuenta: string;
    fechaEmision: any;
    monto: any;
    estado: string;  
   
      
}

export class RecibosAgenciaMod implements RecibosAgenciaMod {
    constructor(init?: RecibosAgenciaFormValues) {
        Object.assign(this, init);
    }
}

export class RecibosAgenciaFormValues {
    id: number = 0
    idCliente: string = "";
    cuenta: string = "";
    fechaEmision: Date | null = null;
    monto: number = 0;
    estado: string = "";   
    
    
   
    
    constructor(ReciboAgenciaMod?: RecibosAgenciaFormValues) {
        if (ReciboAgenciaMod) {
            this.id = ReciboAgenciaMod.id;
            this.idCliente = ReciboAgenciaMod.idCliente;
            this.cuenta = ReciboAgenciaMod.cuenta;
            this.fechaEmision = ReciboAgenciaMod.fechaEmision;  
            this.monto = ReciboAgenciaMod.monto;                      
           
            
        }

    }
}
